import useTheme from "../../context/ThemeProvider";
import { LinearGradient } from "react-text-gradients";

const GradientText = ({ text }) => {
    const { theme } = useTheme();

    if (theme === 'light') {
      return <LinearGradient gradient={['to left', '#743EC7, #4153FD, #1E234C']}>
        {text}
      </LinearGradient>
    } else {
      return <LinearGradient gradient={['to left', '#4153FD, #e6f5eb']}>
        {text}
      </LinearGradient>
    }
}

export default GradientText;